[
  {
      "Internal/External": "Both",
      "name": "Prof. Lau Sian Lun",
      "company": "Sunway University",
      "position": "Associate Dean and Head",
      "photo": "https://data.vhackusm.com/judges/1Kg0TyPntTfr4gmhLWnjl9mgEmFa-vK0p.jpg"
  },
  {
      "Internal/External": "Both",
      "name": "Mr. Yap Mun Foong",
      "company": "Neptrix",
      "position": "Director",
      "photo": "https://data.vhackusm.com/judges/11NNogLL8bESTaXk3kw3mYAhPxxMQdf-J.jpg"
  },
  {
      "Internal/External": "Both",
      "name": "Mr. Howie Chang",
      "company": "Forward School",
      "position": "CEO",
      "photo": "https://data.vhackusm.com/judges/1Zq0HAS5Ff26uVmJQLTejym8QcoXWxUFe.jpg"
  },
  {
      "Internal/External": "Both",
      "name": "Mr. Yeoh Ru Sern",
      "company": "Intel Corporation",
      "position": "Data Scientist",
      "photo": "https://data.vhackusm.com/judges/1jLYWdtTQae9gAFtb54ydpsvrXCB4tztq.jpg"
  },
  {
      "Internal/External": "External only",
      "name": "Mr. Lim Kok Leong",
      "company": "NCS (Singtel)",
      "position": "Senior Product Manager",
      "photo": "https://data.vhackusm.com/judges/1Dzf0F8xib6aighLs_f0sHYBaBozfGD_f.jpg"
  },
  {
      "Internal/External": "External only",
      "name": "Mr. Leong Yok Tien",
      "company": "Hackathon Kaki",
      "position": "Co-founder",
      "photo": "https://data.vhackusm.com/judges/1xwwylHALGN0AUn4uE25rIZkdWoVDjMKQ.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Kee Chong Wei",
      "company": "Telebort Technologies Sdn. Bhd.",
      "position": "Executive Director",
      "photo": "https://data.vhackusm.com/judges/1OgAvF44hXOWgi_D4i46ju90reip7EcNr.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Ts. Lee Jian Aun",
      "company": "Springtech Ventures Sdn. Bhd.",
      "position": "Chief Technology Officer",
      "photo": "https://data.vhackusm.com/judges/1t2TV7rm82bgtuozMBdQPL-pPKRd7ZULn.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Ts. Dr. Cheng Wai Khuen",
      "company": "Universiti Tunku Abdul Rahman",
      "position": "Deputy Dean of Faculty of Information and Communication Technology",
      "photo": "https://data.vhackusm.com/judges/12w_ZeR6ln4GQYhqsopUkJ4aH7mBlzUG0.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Tay Shu Yih",
      "company": "EasyWork Asia Sdn. Bhd.",
      "position": "CTO",
      "photo": "https://data.vhackusm.com/judges/1QuBzr00kRZFE3m39V_h1Uh66-D9ZK_9v.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Chow Kin Weng",
      "company": "NI Malaysia Sdn. Bhd.",
      "position": "Senior Software Engineering Manager",
      "photo": "https://data.vhackusm.com/judges/1FWUJct3FKYe35Sc2qzFcJhqEMj0RI8Cn.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Lau Kok Hwa",
      "company": "KH Software Services",
      "position": "Founder",
      "photo": "https://data.vhackusm.com/judges/1WuDu_9pebIJ5Rvo-zOx6djGarONXNAyv.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Yeoh Shih Hoong",
      "company": "ViTrox Technologies Sdn. Bhd.",
      "position": "Senior Vice President",
      "photo": "https://data.vhackusm.com/judges/1I5-J7Hvky2_losWmRgJ0yVdf669fDhCw.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mrs. Mageshwari Valachamy",
      "company": "MAMPU /UTM",
      "position": "Senior Assistant Director ",
      "photo": "https://data.vhackusm.com/judges/1MebQTHgcCS60EVc6b_PaZdN7zO7RciXY.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Kiarash Razaghiaval",
      "company": "Juris Technologies",
      "position": "Chief Information Officer",
      "photo": "https://data.vhackusm.com/judges/1sJOR4v-3SmZnbrlhGoFnjcXzHHsRrEF4.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Lim Kian Long",
      "company": "Dell Technologies",
      "position": "Principal Software Engineer",
      "photo": "https://data.vhackusm.com/judges/1pNcvvhn66ub-A2Nf4rwil6mo4qQj8Ao9.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Ts. Mohammad Aizat Bin Basir",
      "company": "Universti Malaysia Terengganu",
      "position": "Senior Lecturer",
      "photo": "https://data.vhackusm.com/judges/1pgcBpfdNOxrdJmwA7-y8aPh2fHQGFGIo.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Khoo Yak Hua",
      "company": "ViTrox",
      "position": "Senior R&D Manager",
      "photo": "https://data.vhackusm.com/judges/1WVA6J9h-okqOGcSVL7hIjUm9Gv50IRgg.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Ms. Chong Yung Wey",
      "company": "Universiti Sains Malaysia",
      "position": "Senior Lecturer",
      "photo": "https://data.vhackusm.com/judges/1WJ1KAl5jR5du9RagfyK3wJmSY6cFAHzu.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Ms. Nursakirah Ab Rahman Muton",
      "company": "UOW Malaysia KDU Penang<br> University College",
      "position": "Computing Lecturer",
      "photo": "https://data.vhackusm.com/judges/1TFQJXfxjaDdEcEmiCbjL_Pdmq4XxMTcs.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Iman Haris Bin Hadi",
      "company": "Netizen Experience",
      "position": "Software Engineer",
      "photo": "https://data.vhackusm.com/judges/1xp5qd-AMG6-o3nt9dyot4ieTxP-kmU4L.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Ahmad Ferdaus Abd Razak",
      "company": "NI Malaysia Sdn. Bhd.",
      "position": "Principal Cloud Services Engineer",
      "photo": "https://data.vhackusm.com/judges/1w-ktb4h1949DXhZuctfnWEh1eGznBXhc.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Abdul Salam Bin Waqar Ahmed",
      "company": "Maxis Sdn. Bhd.",
      "position": "Mobile Developer",
      "photo": "https://data.vhackusm.com/judges/1mGP_uerbFAAjnH-fQPrUyKG_Hj_GMxTQ.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Ooi Boon Sheng",
      "company": "Web Bytes Sdn. Bhd.",
      "position": "CEO",
      "photo": "https://data.vhackusm.com/judges/1W4co7eUTeyxQy9LQNTR1XRdTws61jCx2.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Dr. Muhammed Dzulkhiflee Bin Hamzah",
      "company": "Hilti Asia IT Services Sdn. Bhd.",
      "position": "IT Product Owner",
      "photo": "https://data.vhackusm.com/judges/1FQeTaLenJP96vRlIp6uqr5-rFkwKCs-s.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Eng Aik Kian",
      "company": "Web Bytes Sdn. Bhd.",
      "position": "CTO",
      "photo": "https://data.vhackusm.com/judges/1T2SKBrW8vMc7VYptzNlm-q758tQNiNCz.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Jason Low Wei Shang",
      "company": "Virtualtech Frontier",
      "position": "Virtualization Director",
      "photo": "https://data.vhackusm.com/judges/1F7lKxCQe9TonTMmbV80wZBjg667xhu4M.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Mohd Yashim Wong Paul Tze",
      "company": "Deriv Services Sdn. Bhd.",
      "position": "Tech Lead",
      "photo": "https://data.vhackusm.com/judges/1dP7YXEK1mdRsOvlZnR-1wtDnhTvOZe1M.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Tan Wei Kit",
      "company": "Web Bytes Sdn. Bhd.",
      "position": "Business Development Director",
      "photo": "https://data.vhackusm.com/judges/1E4k4Xrhwulran_UZUwI1TQqb9zQ_ta-1.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Seyed Mohammad Matin Shafiei",
      "company": "Deriv Services Sdn Bhd.",
      "position": "Frontend Team Lead",
      "photo": "https://data.vhackusm.com/judges/1XIKk6tbDxy4RJWCqBRwNa45TMJrKQiiO.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Joel Nathanael",
      "company": "Micro Modular System Sdn. Bhd.",
      "position": "Senior Manager",
      "photo": "https://data.vhackusm.com/judges/17hXtdxotXgXQpErf9ajUTzwKKRJIET1T.jpg"
  },
  {
      "Internal/External": "Internal only",
      "name": "Mr. Chew Wei Choon",
      "company": "Micro Modular System Sdn. Bhd.",
      "position": "Manager",
      "photo": "https://data.vhackusm.com/judges/1SWDFJs7s9psCLX9-yrP54MlASFgRd8Pz.jpg",
      "img": "../assets/cssociety-logo.png"
  }
]